import React from "react";
import { node } from "prop-types";
import styles from "./cardTagListing.module.css";
export var CardTagsListing = function CardTagsListing(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("ul", {
    className: styles["jds-CardTagsListing"]
  }, React.Children.map(React.Children.toArray(children), function (child) {
    return /*#__PURE__*/React.createElement("li", {
      className: styles["jds-CardTagsListing__item"],
      key: child.key
    }, child);
  }));
};
CardTagsListing.propTypes = {
  children: node.isRequired
};